module.exports = __webpack_public_path__ + "static/img/brees-2009-slide-4.f573485.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2009-slide-4.jpg
// module id = D+BP
// module chunks = 1